import { combineReducers } from "redux";
// import { routerReducer } from "react-router-redux";
import { actionTypes } from './constants';

const { todoTypes } = actionTypes;

// reducer:
// pure function, never mutating input, same input get same output
// 接收當下 state 以及 action，傳回新 state
// 常以負責的 state 命名

function todos(todos = [], action) {
  switch(action.type) {
    case todoTypes.addTodo:
      return [
        ...todos,
        {
          text: action.text,
          completed: false
        }
      ];
    default:
      return todos;
  }
}

// combining reducers
export const reducers = combineReducers({
  todos
});


// WEBPACK FOOTER //
// ./src/redux/reducers.js